module.exports = __webpack_public_path__ + "img/infrastructure-23.4b72cfa5.png";